import { ASSET_URL, DEFAULT_CATEGORY_ICON_SIZE } from '~/constants';
import { usePartnerConfig } from '~/context/PartnerConfigContext';

type CategoryIconProps = {
  slug?: string | null;
  name: string;
  iconSize?: number;
};

export const CategoryIcon = ({ slug, name, iconSize = DEFAULT_CATEGORY_ICON_SIZE, ...props }: CategoryIconProps) => {
  const config = usePartnerConfig();
  const partnerId = config?.id;
  const hasCustomAssetPath = Boolean(config?.configuration?.hasCustomAssetPath);
  const assetPath = hasCustomAssetPath && partnerId ? `${ASSET_URL}/${partnerId}` : ASSET_URL;

  return (
    <img src={`${assetPath}/${slug}.svg`} alt={`${name} icon`} width={iconSize} height={iconSize} {...props} />
  );
};
